<div class="container">
    <table
        mat-table
        [dataSource]="actions()"
        class="drop-table mat-elevation-z8"
        cdkDropList
        [cdkDropListData]="actions()"
        (cdkDropListDropped)="onActionDrop($event)"
        [cdkDropListDisabled]="disabled === true">
        <ng-container matColumnDef="order">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" class="drop-cell">
                <fa-icon cdkDragHandle [ngClass]="{ 'drag-handle': disabled === false }" [icon]="faGripLinesVertical"></fa-icon>
            </td>
        </ng-container>
        <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

        <!-- Colonne 'Nom' -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="column-name">Nom</th>
            <td mat-cell *matCellDef="let element" class="column-name drop-cell">{{ element.name }}</td>
        </ng-container>

        <!-- Colonne 'Type' -->
        <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef class="column-value">Type</th>
            <td mat-cell *matCellDef="let element" class="column-value drop-cell">{{ actionTypes.get(element.type) }}</td>
        </ng-container>

        <!-- Colonne 'Actions' -->
        <ng-container matColumnDef="actions" stickyEnd>
            <th mat-header-cell *matHeaderCellDef aria-label="column actions" class="action-column">
                <button mat-icon-button [disabled]="disabled" (click)="onCreateAction()" aria-label="Ajouter une action" class="accent-button">
                    <mat-icon>add</mat-icon>
                </button>
            </th>
            <td mat-cell *matCellDef="let element" class="drop-cell">
                <button mat-icon-button [disabled]="disabled" [matMenuTriggerFor]="menu" [matMenuTriggerData]="{ element: element }" aria-label="Menu contextuel">
                    <mat-icon>more_vert</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            cdkDrag
            cdkDragPreview
            [cdkDragData]="row"
            class="element-row drop-table-item"
            (dblclick)="onMouseDoubleClick(row, $event)"></tr>
    </table>

    <mat-menu #menu="matMenu">
        <ng-template matMenuContent let-element="element">
            <button mat-menu-item [disabled]="disabled" (click)="onEditAction(element)">
                <mat-icon>edit</mat-icon>
                <span>Editer</span>
            </button>
            <button mat-menu-item [disabled]="disabled" (click)="onDuplicateAction(element)">
                <mat-icon>edit</mat-icon>
                <span>Dupliquer</span>
            </button>
            <button mat-menu-item [disabled]="disabled" (click)="onDeleteAction(element)">
                <mat-icon>delete</mat-icon>
                <span>Supprimer</span>
            </button>
        </ng-template>
    </mat-menu>
</div>
